import sendNoteTemplate from './send-note.html';
import template from './top-header.html';
import logo from './../../assets/images/swietlica.svg';

class TopHeaderComponent {
  /** @ngInject */
  constructor(
    $log, $state, $location, $window, $mdDialog, $localStorage, $sce
  ) {
    'ngInject';
    this.logo = logo;
    this.$log = $log;
    this.$state = $state;
    this.$location = $location;
    this.$window = $window;
    this.$mdDialog = $mdDialog;
    this.$localStorage = $localStorage;
    this.$sce = $sce;
  }

  $onChanges(changes) {
    if (changes.user) {
      this.user = {...this.user};
    }

    if (changes.me) {
      this.me = {...this.me};
    }
  }

  svgToHtml(svg) {
    return this.$sce.trustAsHtml(svg);
  }

  redirect(url) {
    if (url.length === 0) {
      url = '/interfejs_lekcyjny';
      if (this.user.isAdmin) {
        url = '/uzytkownicy';
      } else if (this.user.isPedagogue) {
        url = '/pedagog_uczniowie';
      }
    }

    this.$window.location.href = this.$location.protocol() + '://' + this.$location.host() + url;
  }

  logout() {
    this.$localStorage.$reset();
    this.$window.location.href = this.$location.protocol() + '://' + this.$location.host() + '/wyloguj';
  }

  openNewTab(url, ev) {
    ev.stopPropagation();
    this.$window.open(this.$location.protocol() + '://' + this.$location.host() + url, '_blank');
  }

  openHelp(ev) {
    ev.stopPropagation();
    let url = '';
    switch (this.me.roleName) {
      case 'MANAGER':
        url = '/help/a601';
        break;
      case 'HEAD_TEACHER':
        url = '/help/a602';
        break;
      case 'TEACHER':
        url = '/help/a602';
        break;
      case 'EMPTY':
        url = '/help/a602';
        break;
      default:
        url = '/help/a599';
    }

    this.$window.open(this.$location.protocol() + '://' + this.$location.host() + url, '_blank');
  }

  sendNote(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'SendNoteController',
      template: sendNoteTemplate,
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: ev
    });
  }
}

export const TopHeader = {
  bindings: {
    user: '<',
    me: '<'
  },
  template,
  controller: TopHeaderComponent,
  controllerAs: 'vm'
};
